document.addEventListener('DOMContentLoaded', () => {
  const swiperTabsNav = new Swiper('.swiper-tabs-nav', {
    spaceBetween: 0,
    slidesPerView: 4,
    loop: false,
    loopedSlides: 5,
    autoHeight: false,
    resistanceRatio: 0,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  new Swiper('.swiper-tabs-content', {
    spaceBetween: 0,
    loop: false,
    noSwiping: true,
    noSwipingClass: 'swiper-slide',
    longSwipes: true,
    resistanceRatio: 0, // Disable First and Last Swiper
    watchOverflow: true,
    loopedSlides: 5,
    thumbs: {
      swiper: swiperTabsNav,
    },
  });

  const materialName = document.querySelector('.material-name');
  const materialContent = document.querySelector('.material-content');
  const materialImage = document.querySelector('.material-image');
  const tabColors = document.querySelectorAll('.content-tab-color .tab-color');
  if (tabColors) {
    tabColors.forEach((tabColor) => {
      if (!tabColor) return;

      tabColor.addEventListener('click', () => {
        if (tabColor.classList.contains('tab-active')) return;

        const prevActive = document.querySelector('.content-tab-color .tab-color.tab-active');
        if (prevActive) prevActive.classList.remove('tab-active');

        tabColor.classList.add('tab-active');

        if (materialName && tabColor.dataset.name) {
          materialName.innerHTML = tabColor.dataset.name || '';
        }

        if (materialContent && tabColor.dataset.content) {
          materialContent.innerHTML = tabColor.dataset.content || '';
        }

        if (materialImage && tabColor.dataset.image && tabColor.dataset.image != '') {
          materialImage.src = tabColor.dataset.image;
        }
      });
    });
  }
});
